import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DragOutlinedSvg from "@ant-design/icons-svg/es/asn/DragOutlined";
import AntdIcon from '../components/AntdIcon';
var DragOutlined = function DragOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: DragOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(DragOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'DragOutlined';
}
export default RefIcon;